import {
  Box,
  HStack,
  Icon,
  Image,
  Text,
  useBreakpointValue,
  useMediaQuery
} from '@chakra-ui/react';

import Rectangle from '../../assets/Rectangle-laranja.svg';
export const StepsLead = ({
  color,
  text,
  value,
  ...props
}: any): JSX.Element => {
  const [isLargerThan1440] = useMediaQuery('(min-width: 1440px)');
  return (
    <HStack justifyContent="center" alignItems="center" {...props}>
      <Icon
        viewBox="0 0 312 70"
        w={{ base: '40vh', sm: '22vw' }}
        h={{ base: '10vh', sm: '12vh' }}
      >
        <svg
          width="312"
          height="72"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.1518 8.83642C-1.35184 5.5446 0.995789 0.80957 5.13152 0.80957H282.995C284.538 0.80957 285.995 1.52208 286.942 2.74022L310.66 33.2402C312.064 35.0456 312.064 37.5735 310.66 39.3789L286.942 69.8789C285.995 71.0971 284.538 71.8096 282.995 71.8096H5.13152C0.995786 71.8096 -1.35185 67.0746 1.15179 63.7827L19.7448 39.3364C21.1051 37.5478 21.1051 35.0714 19.7448 33.2827L1.1518 8.83642Z"
            fill={`${color}`}
          />
        </svg>
      </Icon>
      {/* <Image src={svgManipulate} color="telegram.900" w="400vh"/> */}

      <Text
        fontWeight="medium"
        color="#fff"
        position="absolute"
        fontSize={isLargerThan1440 ? '2.2vh' : '1.8vh'}
      >
        {text}
        {value ? ' (' + value + ')' : ''}
      </Text>
    </HStack>
  );
};
